import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Link from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'

const BreadcrumbPanel = ({ breadcrumbs: [{ title, backLink }] }) =>
  <Wrapper data-max-width>
    <CustomLink to={ backLink }>
      <BackIcon asset="arrow-left" alt="" height={ 12 } />
      { title }
    </CustomLink>
  </Wrapper>

BreadcrumbPanel.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      backLink: PropTypes.string,
      title: PropTypes.string
    })
  )
}

export default BreadcrumbPanel

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '20px 0', '20px 0 20px 10px')}
`

const CustomLink = styled(Link)`
  &::before {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
`
const BackIcon = styled(Icon)`
  margin: -2px 8px 0 0;
`
